import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { SessionService } from '@ildes/services/session.service';
import { ToastService } from '@ildes/services/toast.service';

@Component({
  selector: 'app-renew-session-dialog',
  standalone: true,
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    SimpleHeaderComponent,
    MatProgressBarModule,
    CommonModule,
  ],
  template: `
    <simple-header [title]="'Hola, ' + user.name" (action)="onClose()" icon="close"></simple-header>
    <div>
        <p>Introduzca su password para poder usar ildes con normalidad</p>
        <form [formGroup]="credentials" class="padding-top-8 padding-bottom-8">
        <div>
          <mat-form-field appearance="outline"  class="full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password">
            <mat-error>
                La contraseña es obligatoria
            </mat-error>
          </mat-form-field>
        </div>
        <div class="align-center">
          <div class="padding-bottom-8">
            <button (click)="onSubmitCredentials()" [disabled]="credentials.invalid || loading" mat-raised-button color="primary" class="button-size-200">Renovar sesión</button>
          </div>
          <div>
            <!-- <button mat-button>He olvidado la contraseña</button> -->
            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
      </form>
    </div>
  `,
  styleUrls: ['./renew-session-dialog.component.css'],
})
export class RenewSessionDialogComponent {
    user;
    loading;
    credentials = new FormGroup({
        'password': new FormControl('', [Validators.required])
    })
    constructor(
        public dialogRef: MatDialogRef<RenewSessionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private sessionService: SessionService,
        private toast: ToastService,
    ) {
        this.user = data.user;
    }

    onSubmitCredentials() {
        this.loading = true;
        this.sessionService.create(
            this.user.email.toLowerCase(),
            this.credentials.controls.password.value,
            true,
            false
        ).subscribe(() => {
            this.toast.show('Vuelve a tener sesión', 'ok');
            this.loading = false;
            this.dialogRef.close();
        }, (e) => {
            if (e.status === 403) {
                this.toast.show('Contraseña incorrecta', 'error');
            } else {
                this.toast.show('No pudo iniciar sesión', 'error');
            }
            
            this.loading = false;
        })
    }

    onClose() {
        this.dialogRef.close();
    }

}
